import React from 'react';

export type TooltipProps = {
    text: string;
    children: React.ReactNode;
};

export const Tooltip: React.FC<TooltipProps> = ({ text, children }) => {
    return (
        <span className="relative inline-flex items-center group">
            {children}
            {text && (
                <span className="absolute bottom-full mb-2 hidden group-hover:inline-block bg-gray-800 text-white text-sm rounded py-1 px-2">
                    {text}
                </span>
            )}
        </span>
    );
};